import React from 'react';
import GalleryContent from './GalleryContent';
import withGalleryManager from '../withGalleryManager';
import PropTypes from 'prop-types';
import ExpandTextPanel from '../../common/ExpandText';
import DoOnMobileButton from '../../common/DoOnMobileButton';
import DeleteButton from './DeleteButton';

class GalleryInPage extends React.Component {
  render = () => {
    // noinspection CheckTagEmptyBody
    const galleryIsDone = this.props.images.size > 0;
    return (
      <div className="gallery-inpage desktop-gallery document-page-container">
        <div className="common-full-height-page-content">
          <div
            className="desktop-popup-header"
            style={{ marginBottom: 5, border: 'none' }}
          >
            {this.props.document.name}
          </div>
          <div className="document-page-body tinny-scrollbar">
            {this.props.document.hint && (
              <ExpandTextPanel margin={20}>
                <label className={'documentHint'}>
                  {this.props.document.hint}
                </label>
              </ExpandTextPanel>
            )}
            <GalleryContent
              {...this.props}
              xmSizeAtCount={9}
              xsSizeAtCount={20}
              showAddImageCard
            />
          </div>
          {!this.props.scanEnded && !(this.props.embedMode && !galleryIsDone) && (
            <div className="document-page-footer">
              <DoOnMobileButton
                onClick={this.props.onContinueGalleryOnMobile}
              />

              <div className={'buttons'}>
                {galleryIsDone && (
                  <DeleteButton
                    animateTitle
                    onDeleteClick={this.props.onDeleteAllClick}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };
}

GalleryInPage.propTypes = {
  onContinueGalleryOnMobile: PropTypes.func,
  onDeleteAllClick: PropTypes.func,
  document: PropTypes.object,
  scanEnded: PropTypes.bool,
  embedMode: PropTypes.bool,
  images: PropTypes.object
};

export default withGalleryManager(GalleryInPage);
